const footerLinks = [
  {
    group: '快速导航',
    items: [
      { label: '视频爆料', href: '#media' },
      { label: '最新瓜料', href: '#cards' },
      { label: '热度榜单', href: '#ranking' },
      { label: '焦点专题', href: '#carousel' },
      { label: '热门话题', href: '#topics' },
    ],
  },
  {
    group: '关于我们',
    items: [
      { label: '平台介绍', href: '#about' },
      { label: '投稿爆料', href: '#contact' },
      { label: '常见问题', href: '#faq' },
      { label: '移动吃瓜', href: '#app' },
    ],
  },
  {
    group: '合作伙伴',
    items: [],
  },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-800 text-background-200">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <span className="text-xl font-heading text-background-50 mb-3 block">爆料网</span>
            <p className="text-sm text-background-400 leading-relaxed">
              国内领先的网红圈八卦娱乐资讯聚合平台。覆盖直播圈、短视频圈、娱乐圈、电竞圈、电商圈，每日更新最新网红吃瓜黑料八卦，一网打尽。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.group}>
              <h4 className="text-sm font-medium text-background-100 mb-3">{group.group}</h4>
              {group.group === '合作伙伴' ? (
                <p className="text-sm text-background-500">暂无合作伙伴信息</p>
              ) : (
                <ul className="space-y-2">
                  {group.items.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-sm text-background-400 hover:text-background-100 transition-colors no-underline"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        <div className="border-t border-secondary-600 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2023-2026 爆料网 baoliaowang.com 版权所有
          </p>
          <p className="text-xs text-background-500">
            本站内容来源于公开信息及用户投稿，仅供参考。如涉及侵权请通过投稿通道联系处理。
          </p>
        </div>
      </div>
    </footer>
  );
}